import Vue from 'vue'
import {Toast} from 'mint-ui'

class Alert {
	constructor (duration=800){
		this.duration = duration
	}

	success (message='',duration=this.duration){
		Toast({
			message,
			duration
		})
	}
}
let alert = new Alert();
// console.log(alert.success);
// Vue.prototype.$bdAlert = alert;
// console.log(Vue.prototype.$bdAlert.success)
export default {
	install (){
		Vue.prototype.$bdAlert = alert
	}
}



// WEBPACK FOOTER //
// ./src/common/alert.js